// extracted by mini-css-extract-plugin
export default {"container":"TitleBlock_container__hw0m8","text":"TitleBlock_text__M2fvx"};